import React from 'react';
import { EmbeddedHTMLPageType } from '../../../lib/api/custom-page.types';
import { arePageFlagsPending, useEventSettings } from '../../../lib/context-providers/event-settings-context/event-settings-context';


export const EmbeddedHTMLCustomPage: React.FunctionComponent<EmbeddedHTMLPageType> = (props: EmbeddedHTMLPageType): JSX.Element | null => {
  const eventSettings = useEventSettings();
  if (arePageFlagsPending(eventSettings)) return null;

  if (props && props.htmlUrl) return (
    <iframe
      width='100%'
      height='100%'
      title={props.label}
      src={props.htmlUrl}
      sandbox='allow-scripts allow-same-origin allow-forms allow-popups allow-modals allow-downloads allow-popups-to-escape-sandbox allow-top-navigation-by-user-activation'
    />
  );
  return null;
};
